import React from "react";
import { Pagination, Card, Row, Col } from "antd";
import 'antd/dist/antd.css';
import AlertComponent from "../../../helpers/AlertPage";
import NewsCard from "./NewsCard";



const pageSize = 6;



const SocialNewsList = ({ items, totalCount, dispatch, isLoading }) => {

    const handlePaginationChange = (page, pageSize) => {
        const paginationData = {
            currentPage: page,
            pageSize: pageSize
        }
        const action = {
            type: "set_pagination",
            payload: paginationData,
        };
        dispatch(action);
    };


    const startInfoItem = (item) => {
        const action = {
            type: "open_consult_view",
            payload: {
                item: item,
                indexVisibility: 1
            }
        };
        dispatch(action);
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                {items?.length === 0 && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>

                            {isLoading === true && (
                                <Row gutter={24}>
                                    {[1, 2, 3].map(() => (
                                        <Col
                                            xl={8} lg={8} md={8} sm={24} xs={24}
                                            style={{ paddingLeft: "10px", paddingRight: "10px", paddingBottom: "20px" }}
                                        >
                                            <Card loading={isLoading} style={{ minHeight: "200px" }} />
                                        </Col>
                                    ))}
                                </Row>
                            )}

                            {isLoading === false && (
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <div className="example mt-4">
                                            <AlertComponent name="lajm"></AlertComponent>
                                        </div>
                                    </Col>
                                </Row>
                            )}

                        </Col>
                    </Row>
                )}

                {items.length !== 0 && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <Row>
                                {isLoading && (
                                    [1, 2, 3].map(() => (
                                        <Col
                                            xl={8} lg={8} md={8} sm={24} xs={24}
                                            style={{ paddingLeft: "10px", paddingRight: "10px", paddingBottom: "20px" }}
                                        >
                                            <Card loading={isLoading} style={{ minHeight: "200px" }} />
                                        </Col>
                                    ))
                                )}

                                {!isLoading && items?.map((elm) => (
                                    <Col
                                        xl={8} lg={8} md={8} sm={24} xs={24}
                                        style={{ paddingLeft: (elm?.index !== 1 && elm?.index !== 4) && "10px", paddingRight: elm?.index % 3 !== 0 && "10px", paddingBottom: "20px" }}
                                    >
                                        <Card
                                            hoverable
                                            bodyStyle={{ padding: "0px" }}
                                            className="w-100"
                                            onClick={() => startInfoItem(elm)}
                                        >
                                            <NewsCard item={elm} />
                                        </Card>
                                    </Col>
                                ))}

                            </Row>
                            <Row gutter={24} className="mt-4">
                                <Col span={24}>

                                    {items.length !== 0 && (
                                        <Row gutter={24} className="text-center">
                                            <Col span={24}>
                                                <Pagination
                                                    pageSize={pageSize}
                                                    defaultCurrent={1}
                                                    total={totalCount}
                                                    onChange={handlePaginationChange}
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )}
            </Col>
        </Row>
    );
};


export default SocialNewsList;